// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileCategoryHeader{padding:5px 5px 0}.MobileCategoryHeader h1{color:#0a6a97;font-family:"UbuntuBold",Arial,Helvetica,sans-serif;font-size:19px;margin-top:0;margin-bottom:10px}.MobileCategoryHeader h2{color:#666;font-family:"UbuntuBold",Arial,Helvetica,sans-serif;font-size:14px;margin-bottom:17px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
